import axios from "axios";

export const medicamentosSugeridos = async (codigos) => {
  const { data } = await axios.get("/api/medicamentos_Sugeridos/", {
    params: { codigos },
  });
  return data;
};
